<template>
  <v-btn color="info"
         small
         outline
         @click="goTo('newRate', { shipmentId: shipment.id })"
         v-if="showRateBtn"
         >
         {{ $t('selectRate') }}
  </v-btn>
</template>

<script>
export default {
  name: 'ShipmentRateBtnComp',

  props: {
    shipment: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
    }
  },

  components: {
  },

  computed: {
    showRateBtn () {
      return this.shipment.step === 'rating'
    }
  },

  methods: {
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
